export const socialsData = {
    github: 'https://github.com/AbdelrahmanHs86',
    facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/abd-linked',
    instagram: 'https://www.instagram.com/',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/abdelrahmanAB4',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/'
}